import { styled } from "styled-components";
import { IcbtRequest, ProgressByProgramId } from "api/types";
import { TFunction } from "react-i18next";
import * as R from "remeda";
import { ProgramsAndTreatments } from "../../../hooks/icbt/useGetAllProgramsAndTreatmentsQuery";

export const List = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-basis: auto;
`;

export type PossiblyErrors = {
  programsAndTreatmentsError: unknown;
  icbtRequestsError: unknown;
  allProgressError: unknown;
};

export const mapTreatmentData = (
  programsAndTreatments: ProgramsAndTreatments | undefined,
  icbtRequests: IcbtRequest[] | undefined,
  allProgress: ProgressByProgramId | undefined,
  t: TFunction,
) => {
  if (!programsAndTreatments) {
    return {
      byId: {},
      sorted: [],
    };
  }

  const mappedTreatmentById = R.pipe(
    programsAndTreatments.treatments,
    R.mapValues(
      ({ programs, title, standaloneProgramsContainer, ...rest }) => ({
        ...rest,
        standaloneProgramsContainer,
        // Use correct name for standalone programs container
        title: standaloneProgramsContainer
          ? t("ICBT_STANDALONE_PROGRAMS")
          : title,
        // Sort standalone programs by title
        programs: (standaloneProgramsContainer
          ? R.sortBy(programs, R.prop("title"))
          : programs
        ).map((program) => {
          const assignment = icbtRequests?.find(
            (request) =>
              request.programId === program.id && request.isLatestRequest,
          );

          return {
            ...program,
            completed: allProgress
              ? Boolean(allProgress[program.id]?.completedAt)
              : false,
            assigned: Boolean(assignment),
            started: allProgress
              ? Boolean(allProgress[program.id]?.maxProgressedPageId)
              : false,
            isReassignable: Boolean(assignment?.isReassignable),
          };
        }),
      }),
    ),
  );

  const sortedTreatments = R.pipe(
    mappedTreatmentById,
    R.values,
    R.sortBy.strict(R.prop("title")),
  );

  return {
    byId: mappedTreatmentById,
    sorted: sortedTreatments,
  };
};

export type MappedTreatmentData = ReturnType<typeof mapTreatmentData>;
